import React from 'react'
import { Layout, Intro, SectionTitle, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        complete={true}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Titles describe the main purpose of a screen and any content
            subsections in a given layout. Font size, weight and color will
            depend on usage, as defined in the variants below.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <div className="showcase__title l-margin-top--xxlarge">Title 1</div>
        <p>
          Use for the Title element that belongs in the first level of the
          visual hierarchy. This will usually be the headline title which will
          appear only once per page.
        </p>
        <table class="showcase-table">
          <thead>
            <th> </th>
            <th>Weight</th>
            <th>Color</th>
            <th>Font Values</th>
            <th>Usage</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <h1 class="c-title-1--normal">Title1/Normal</h1>
              </td>
              <td>SemiLight 200</td>
              <td>#007856</td>
              <td class="showcase-table__font-values">
                font-size: <strong>32px</strong>
                <br />
                line-height: <strong>40px</strong>
              </td>
              <td class="showcase-table__usage">
                For first level titles on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <h1 class="c-title-1--light">Title1/Light</h1>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>32px</strong>
                <br />
                line-height: <strong>40px</strong>
              </td>
              <td class="showcase-table__usage">
                For first level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>

        <div className="showcase__title">Title 2</div>
        <p>
          Use for any Title elements that belong in the second level of the
          visual hierarchy. This will usually be section header titles.
        </p>
        <table class="showcase-table">
          <tbody>
            <tr>
              <td>
                <h2 class="c-title-2--normal">Title2/Normal</h2>
              </td>
              <td>SemiLight 200</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>24px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For second level titles on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <h2 class="c-title-2--light">Title2/Light</h2>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>24px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For second level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <div className="showcase__title">Title 3</div>
        <p>
          Use for any Title elements that belong in the third level of the
          visual hierarchy. This will usually be section or subsection header
          titles.
        </p>
        <table class="showcase-table">
          <tbody>
            <tr>
              <td>
                <h3 class="c-title-3--normal">Title3/Normal</h3>
              </td>
              <td>Medium 500</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For third level titles on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <h3 class="c-title-3--light">Title3/Light</h3>
              </td>
              <td>Medium 500</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For third level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <div className="showcase__title">Title 4</div>
        <p>
          Use for any Title elements that belong in the fourth level of the
          visual hierarchy. One example of this is the navigation title, found
          in the Intro Area pattern.
        </p>
        <table class="showcase-table">
          <tbody>
            <tr>
              <td>
                <h4 class="c-title-4--normal">Title4/Normal</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <h4 class="c-title-4--subtle">Title4/Subtle</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#D7D7D7</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on dark backgrounds
              </td>
            </tr>
            <tr class="showcase-table__darker-row">
              <td>
                <h4 class="c-title-4--light">Title4/Light</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          All titles are left-aligned. Keep headings closer to the text they
          introduce than the text that precedes them.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Titles can be full sentences or fragments, but try to stay consistent
          within the same layout and flow. Fragments look best when they fit
          onto one line. Use sentence case with no end punctuation unless the
          title is a question.
        </p>
      </Layout>
    </>
  )
}
